<igo-entity-selector
  [store]="store()"
  [multi]="false"
  [titleAccessor]="getWorkspaceTitle"
  [disabled]="disabled()"
  (selectedChange)="onSelectedChange($event)"
/>
